import yup from '../yup-extended';
import { ItemizedBillFormat, MediaWallOutlet, ServiceLevel } from '@cobra/interfaces-enums-mocks/enums';
import { getEnumValues } from '../../helpers/enum';

export const emailSchema = yup
    .string()
    .nullable()
    .trim()
    .label('E-Mail')
    .awbEmail({ excludeEmptyString: true })
    .max(255);
export const mediaWallOutletSchema = yup
    .number()
    .nullable()
    .label('Multimediadose')
    .transform((value) => (value === -1 ? undefined : value))
    .optionalOneOf(getEnumValues(MediaWallOutlet));
export const itemizedBillFormatDesiredSchema = yup
    .number()
    .nullable()
    .label('Rufnummerspeicherung')
    .optionalOneOf([ItemizedBillFormat.SHORTENED, ItemizedBillFormat.COMPLETE], 'Bitte treffen Sie eine Auswahl.');
export const itemizedBillFormatNotDesiredSchema = yup
    .number()
    .nullable()
    .label('Rufnummerspeicherung')
    .optionalOneOf([ItemizedBillFormat.NONE]);
export const telekomKdnrSchema = yup
    .string()
    .nullable()
    .trim()
    .label('Kundennummer')
    .customerNumber({ excludeEmptyString: true })
    .nullable();
export const unknownTelekomKdnrSchema = telekomKdnrSchema.unknownCustomerNumber({ excludeEmptyString: true });
export const ibanSchema = yup
    .string()
    .nullable()
    .trim()
    .label('IBAN')
    .startsWith('DE', { excludeEmptyString: true, message: `Bitte geben Sie eine deutsche IBAN an.` })
    .iban({ excludeEmptyString: true });
export const dtagPrevServiceLevelSchema = yup
    .number()
    .nullable()
    .label('Anschlussart')
    .optionalOneOf(getEnumValues(ServiceLevel));
